import PortableText from "@/components/sanity/PortableText.vue";

// Text section (centered)

export default {
  name: "PostSection6",
  components: {
    PortableText: PortableText
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};